import React from 'react';

import { SVGComponentProps } from './svg.types';

const CloseSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M1.23717 12.7673C0.966844 12.4929 0.866549 12.012 1.268 11.6044L11.4444 1.27206C11.8458 0.864456 12.3194 0.966356 12.5899 1.24097C12.8601 1.51527 12.9437 1.97918 12.5422 2.38678L2.36588 12.7192C1.96444 13.1268 1.50747 13.0418 1.23717 12.7673Z"
          fill={fill}
        />
        <path
          d="M1.41445 1.23694C1.68474 0.962508 2.13439 0.870167 2.53584 1.27777L12.7122 11.6102C13.1136 12.0178 13.0542 12.5063 12.784 12.7808C12.5137 13.0552 12.0322 13.1152 11.6307 12.7076L1.45436 2.37524C1.05292 1.96764 1.14415 1.51139 1.41445 1.23694Z"
          fill={fill}
        />
        <path
          d="M1.23717 12.7673C0.966844 12.4929 0.866549 12.012 1.268 11.6044L11.4444 1.27206C11.8458 0.864456 12.3194 0.966356 12.5899 1.24097C12.8601 1.51527 12.9437 1.97918 12.5422 2.38678L2.36588 12.7192C1.96444 13.1268 1.50747 13.0418 1.23717 12.7673Z"
          stroke={fill}
          strokeWidth="0.6"
        />
        <path
          d="M1.41445 1.23694C1.68474 0.962508 2.13439 0.870167 2.53584 1.27777L12.7122 11.6102C13.1136 12.0178 13.0542 12.5063 12.784 12.7808C12.5137 13.0552 12.0322 13.1152 11.6307 12.7076L1.45436 2.37524C1.05292 1.96764 1.14415 1.51139 1.41445 1.23694Z"
          stroke={fill}
          strokeWidth="0.6"
        />
      </svg>
    </span>
  );
};

export default CloseSVG;
